import React, { useEffect, useRef, useState } from 'react'
import { Modal } from './Modal';

export const SideBarOptions = () => {
    const ref = useRef(null);
    const [showOptions, setShowOptions] = useState(false);
    const [optionType, setOptionType] = useState(null);

    const handleShowOptions = (e) => {
        e.stopPropagation();
        setShowOptions(true);
    }

    const handleClickOption = (type) => {
        setOptionType(type);
        setShowOptions(false);
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setShowOptions(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            <div className='options' onClick={handleShowOptions}>
                &#xFE19;
            </div>
            {showOptions &&
                <div className='options-list' ref={ref}>
                    <div onClick={() => handleClickOption("restore")}>Restore this version</div>
                    <div onClick={() => handleClickOption("copy")}>Make a copy from this version</div>
                </div>
            }
            <Modal type={optionType} onClose={() => setOptionType(null)} />
        </>
    )
}
